import { Box, keyframes } from '@mui/material';

const slideProgress = keyframes`
  0% { left: -45%; }
  100% { left: 105%; }
`;

const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
`;

const LoadingLogo = ({ size = 140, fullScreen = false }) => {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        animation: `${fadeIn} 0.4s ease both`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          component="img"
          src="/simplia.png"
          alt="Simplia"
          sx={{
            height: size,
            width: size,
            objectFit: 'contain',
            animation: `${pulse} 2s ease-in-out infinite`,
          }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </Box>

      <Box
        sx={{
          width: size * 1.1,
          height: 3,
          bgcolor: '#d4d4d7',
          borderRadius: 0,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '45%',
            background: 'linear-gradient(90deg, transparent, #5980a6, transparent)',
            borderRadius: 0,
            animation: `${slideProgress} 1.4s ease-in-out infinite`,
          }}
        />
      </Box>
    </Box>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f2f2f3',
          zIndex: 9999,
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};

export default LoadingLogo;
